import { configureStore } from '@reduxjs/toolkit';
import dataBoxReducer from '../features/dataBoxHomeSlice';
import settingsReducer from '../features/settingSlice';
import userReducer from '../features/userSlice';
import dataMonthReducer from '../features/dataMonthSlice';
import dataYearReducer from '../features/dataYearSlice';
import dataWeekReducer from '../features/dataWeekSlice';
import saldoGraphDataReducer from '../features/saldoGraphDataSlice';
import movimentiReducer from '../features/movimentiSlice';
import documentiReducer from '../features/documentiSlice';
import gasReducer from '../features/gasSlice';
import stimeReducer from '../features/StimeSlice';
import faidateReducer from '../features/faidateSlice';
import altriOneri from '../features/altriOneri';
import navigatorReducer from '../features/navigatorSlice'
import popupReducer from '../features/popupSlice';

export default configureStore({
  reducer: {
    user: userReducer,
    settings: settingsReducer,
    dataBox: dataBoxReducer,
    dataWeek: dataWeekReducer,
    dataMonth: dataMonthReducer,
    dataYear: dataYearReducer,
    saldoGraphData: saldoGraphDataReducer,
    movimenti: movimentiReducer,
    documenti: documentiReducer,
    gas: gasReducer,
    stime: stimeReducer,
    faidate: faidateReducer,
    altriOneri: altriOneri,
    navigator: navigatorReducer,
    popup: popupReducer,
  },
});
